<template>
<div :class="'chat abspage ' + (this.view == 'storyview' ? 'nohpage3' : 'nohpage2')">

	<maincontent>
		<template v-slot:content>

			<linepreloader v-if="loading"/>
			<chat :id="id" :context="context" :view="view" v-if="id && !loading"/>
			<template v-if="!id && !loading">
				<div class="empty" v-if="!cancreate">
					<span>{{$t('caption.chatnotfound')}}</span>
				</div>

				<div class="createChat">
					<template>
						<button class="button" @click="createChatSupport">{{$t('snippity.startChat.' + context)}}</button>
					</template>
				</div>
			</template>


		</template>
	</maincontent>


</div>
</template>

<style lang="sass" scoped>

.createChat,
.empty
	margin-top: 20 * $r
	padding : 2 * $r
	text-align: center
	span
		font-size: 1.5em


</style>

<script>
import chat from "@/components/modules/chats/chat/index.vue";
import f from "@/application/shared/functions.js";

export default {
	name: 'chat_page',
	components: {
		chat
	},

	data : function(){
		return { 
			id : null,
			loading : true,
			view : 'default',
		}
	},

	computed: {
		rid : function(){
            return this.$route.query.id /*|| this.core.*/
        },

		context : function(){
			return this.$route.query.support ? 'support' : (!this.$route.query.id ? 'bot' : 'chat')
		},

		ridcontext : function(){
			return this.rid + this.context
		},

		cancreate : function(){
			return this.context == 'support'
		}
	},

	methods: {

		createChatSupport : function(){
			this.core.api.chat.create.support().then(() => {

				this.load(true)

			})
		},

		getChatId : function(loadInf){
			if(this.rid) return Promise.resolve(this.rid)

			return this.core.user.id().then(id => {

				return f.pretry(() => {
					return this.core.chats.helpers.getChatIdForUserContext(id, this.context)
				}, 0, loadInf ? 0 : 3000).then(() => {
					return this.core.chats.helpers.getChatIdForUserContext(id, this.context)
				})

			})

			
		},
		load : function(loadInf){
			this.loading = true

			this.core.parental('contact', {

			}, () => {

				this.getChatId(loadInf).then(id => {

					if (this.context == 'bot'){
						////TODO setting
						this.view = 'storyview'
					}

					this.id = id

				}).finally(() => {
					this.loading = false
				})

            }, () => {

                return this.context == 'bot'
            })

			
		}
	},

	watch: {

		ridcontext : {
            immediate : true,
            handler : function(){
                this.load()
            }
        }
	},

	mounted() {
		
	}
}
</script>
